@if (isLoading) {
  <div class='sideBarContent content loading-spinner'></div>
}
@if (!isLoading) {
  <div class="sideBarContent editMMCModelDetailComponent content">
    <irb-editor-sidebar-banner
      [isSaveEnable]="false"
      (cancel)="cancel()"
      [accordian]="accordian"
      [showUnsavedChangesWarning]="false"
      [slot]="slot">
      <span header class="ms-header" tooltip [tooltipTitle]="'Model Detail'" [tooltipRequiresTruncation]="true">
        Model Detail
      </span>
      <span buttonsInFront>
        <button class="btn-medium-primary"
          id="editormmcSubscribeButton"
        [disabled]="modelData.isSubscribed || eventData?.readOnlyView" (click)="subscribe()">Subscribe</button>
      </span>
    </irb-editor-sidebar-banner>
    @if (!eventData?.readOnlyView) {
      <div class="previous-next">
        <a data-previous (click)="getPreviousModel()" [class.disabled]="isFirstModel || !saveDisabled"><
        Previous</a>&ensp;|&ensp;
        <a data-next (click)="getNextModel()" [class.disabled]="isLastModel || !saveDisabled">Next ></a>
      </div>
    }
    <div style="height: 100%;padding-bottom:30px;" #body class="irb-editors-edit-model body">
      <!--<div class="block editorDisplayBanner">-->
      <!--Banner-->
    <!--</div>-->
    <div class="block editorDisplayBanner editor-advisor-model-banner">
      <div class="block">
        <div class="subscribe-model-banner-item" style="width:320px;">
          <div class="subscribe-model-banner-title">Manager's Model Name</div>
          <div class="subscribe-model-banner-value">{{ modelData.modelMarketName }}</div>
        </div>
        <div class="subscribe-model-banner-item" style="width:320px;">
          <div class="subscribe-model-banner-title">Manager</div>
          <div class="subscribe-model-banner-value">{{ modelData.modelProviderName}}</div>
        </div>
        <div class="subscribe-model-banner-item">
          <div class="subscribe-model-banner-title">Tax-managed
            <span class="infoIcon"
              calltoaction [calltoactionTemplate]="taxManagedTemplateRef"
            calltoactionPosition="bottom"></span>
            <ng-template #taxManagedTemplateRef>
              If a model is classified as tax managed, the products within the model - as well as the
              allocation changes - are managed to maximize after-tax investment return with the intention
              of minimizing distributions. These models are managed in a way that makes them more suitable
              for taxable accounts.
            </ng-template>
          </div>
          <div class="subscribe-model-banner-value">{{ modelData.taxManaged }}</div>
        </div>
        <div class="subscribe-model-banner-item" style="width:150px;">
          <div class="subscribe-model-banner-title">Asset Type</div>
          <div class="subscribe-model-banner-value">{{ modelData.assetClass?.label }}</div>
        </div>
        <div class="subscribe-model-banner-item" style="width:120px;">
          <div class="subscribe-model-banner-title">Securities</div>
          <div class="subscribe-model-banner-value">{{ modelData.securityList?.length }}</div>
        </div>
        <div class="subscribe-model-banner-item">
          <div class="subscribe-model-banner-title">Strategist Fee
            <span class="infoIcon"
              calltoaction [calltoactionTemplate]="strategistFeeTemplateRef"
            calltoactionPosition="bottom"></span>
            <ng-template #strategistFeeTemplateRef>
              This number represents the cost – in basis points – assessed to the advisor for using this
              model/product. It is otherwise known as a strategist fee. This number does not include the
              underlying fund expenses that an investor will pay for purchasing securities included in the
              model's allocations.
            </ng-template>
          </div>
          <div class="subscribe-model-banner-value">{{ modelData.costBPs }}</div>
        </div>
      </div>
      <div>
        <div class="subscribe-model-banner-title" style="padding-top: 3px;">
          Your notes about this model (optional)
        </div>
        <input type="text" pInputText style="width: 50%;margin-left: 10px;" maxlength="500"
          [(ngModel)]="modelNote" (input)="validateNoteChange()" [disabled]="eventData?.readOnlyView"/>
        <button class="btn-small-secondary" [disabled]="saveDisabled" style="margin-top: 2px;"
          (click)="setAdvisorNote()">Save Note
        </button>
      </div>
    </div>
    <mat-accordion #accordian="matAccordion" [multi]="true">
      <mat-expansion-panel (closed)="localEditorService.updateExpansionState('OVERVIEWDOCUMENTS','closed')"
        (opened)="localEditorService.updateExpansionState('OVERVIEWDOCUMENTS','opened')"
        [expanded]="localEditorService.getDefaultExpansionState('OVERVIEWDOCUMENTS')"
        id="OVERVIEWDOCUMENTS">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Overview Documents / Marketing Materials
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <irb-mmc-overview-marketing-documents [modelData]="modelData"></irb-mmc-overview-marketing-documents>
        </ng-template>
      </mat-expansion-panel>
      <mat-expansion-panel (closed)="localEditorService.updateExpansionState('MMCADVISORSECURITYALLOCATION','closed')"
        (opened)="localEditorService.updateExpansionState('MMCADVISORSECURITYALLOCATION','opened')"
        [expanded]="localEditorService.getDefaultExpansionState('MMCADVISORSECURITYALLOCATION')"
        id="MMCADVISORSECURITYALLOCATION">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Security Allocations
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          @if (securityList && !isUiTest) {
            <irb-mmc-advisor-security-allocations
            [securityList]="securityList"></irb-mmc-advisor-security-allocations>
          }
        </ng-template>
      </mat-expansion-panel>
      <mat-expansion-panel (closed)="localEditorService.updateExpansionState('MMCADVISORSECURITYALLOCATIONCHART','closed')"
        (opened)="localEditorService.updateExpansionState('MMCADVISORSECURITYALLOCATIONCHART','opened')"
        [expanded]="localEditorService.getDefaultExpansionState('MMCADVISORSECURITYALLOCATIONCHART')"
        id="MMCADVISORSECURITYALLOCATIONCHART">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Allocations Chart
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          @if (securityList && !isUiTest) {
            <irb-mmc-allocations-chart categoryLabel="Asset Category"
              [noTarget]="true"
            modelType="Base"></irb-mmc-allocations-chart>
          }
        </ng-template>
      </mat-expansion-panel>
      <mat-expansion-panel (closed)="localEditorService.updateExpansionState('MMCADVISORMODELOVERVIEW','closed')"
        (opened)="localEditorService.updateExpansionState('MMCADVISORMODELOVERVIEW','opened')"
        [expanded]="localEditorService.getDefaultExpansionState('MMCADVISORMODELOVERVIEW')"
        id="MMCADVISORMODELOVERVIEW">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Model Overview
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          @if (modelData) {
            <div>
              <div class="mmc-advisor-left">
                <div class="block">
                  <div class="mmc-advisor-label">Asset class:</div>
                  <div class="mmc-advisor-values">{{modelData.assetClass.label}}</div>
                </div>
                <div class="block">
                  <div class="mmc-advisor-label">Weighted yield:
                    <span class="infoIcon"
                      calltoaction [calltoactionTemplate]="weightedYTemplateRef"
                    calltoactionPosition="bottom"></span>
                    <ng-template #weightedYTemplateRef>
                      The weighted yield is the projected annual income to investors of the model.
                      Only ETFs and mutual funds are considered for this calculation. This value is
                      calculated by multiplying each security's yield by its respective target
                      allocation and summing the result for all securities in the model.
                    </ng-template>
                  </div>
                  <div class="mmc-advisor-values" [innerHTML]="modelData.weightedYield"></div>
                </div>
                <div class="block">
                  <div class="mmc-advisor-label">Building block style:
                    <span class="infoIcon"
                      calltoaction [calltoactionTemplate]="bbsTemplateRef"
                    calltoactionPosition="bottom"></span>
                    <ng-template #bbsTemplateRef>
                      <div class="block">The building block style refers to the ETFs or funds that
                        make up this model - e.g.
                        active, passive, smart beta, or a mix.
                      </div>
                      <div class="block">The holdings in active funds may turn over frequently in an
                        attempt to outperform a
                        benchmark, while the holdings in passive funds are selected to mimic an
                        index. Smart beta funds use
                        a combination of both passive and active strategies while using preset and
                        transparent rules.
                      </div>
                      <p><strong>Please note:</strong> Individual equities are considered passive.</p>
                    </ng-template>
                  </div>
                  <div class="mmc-advisor-values">{{modelData.bbStyle}}</div>
                </div>
                <div class="block">
                  <div class="mmc-advisor-label">Used for:
                    <span class="infoIcon"
                      calltoaction [calltoactionTemplate]="usedForTemplateRef"
                    calltoactionPosition="bottom"></span>
                    <ng-template #usedForTemplateRef>
                      This indicates whether the manager believes this model is best suited for a complete strategy, or best when blended with another model (sleeve).
                    </ng-template>
                  </div>
                  <div class="mmc-advisor-values">{{modelData.used_for}}</div>
                </div>
                <div class="block">
                  <div class="mmc-advisor-label">Risk category:
                    <span class="infoIcon"
                      calltoaction [calltoactionTemplate]="riskCatTemplateRef"
                    calltoactionPosition="bottom"></span>
                    <ng-template #riskCatTemplateRef>
                      Typically, the risk category of the model is defined by the model's volatility
                      range.
                    </ng-template>
                  </div>
                  <div class="mmc-advisor-values">{{modelData.riskTolerance.label}}</div>
                </div>
              </div>
              <div class="mmc-advisor-right" style="vertical-align: top;">
                <!--                            <div class="block" *ngIf="userDetails && !userDetails.isModelProvider">-->
                <!--                                <div class="mmc-advisor-label">FinMason FinScore:-->
                <!--                                    <span class="infoIcon"-->
                <!--                                          calltoaction [calltoactionTemplate]="finScoreTemplateRef"-->
              <!--                                          calltoactionPosition="bottom"></span>-->
              <!--                                    <ng-template #finScoreTemplateRef>-->
              <!--                                        <div [innerHTML]="getFinMasonFinScoreTT()"></div>-->
            <!--                                    </ng-template>-->
          <!--                                </div>-->
          <!--                                <div class="mmc-advisor-values">{{modelData.finscore}}</div>-->
        <!--                            </div>-->
        <div class="block">
          <div class="mmc-advisor-label">Socially responsible:
            <span class="infoIcon"
              calltoaction [calltoactionTemplate]="socRespTemplateRef"
            calltoactionPosition="bottom"></span>
            <ng-template #socRespTemplateRef>
              <div class="block">Socially responsible models are models containing ETFs or mutual funds that hold
                securities in companies that follow certain social, religious, or environmental beliefs.
              </div>
              <div>Schwab does not do any due diligence on this designation; it is solely up to you, the
                investment manager, to ensure that the models are correctly represented.
              </div>
            </ng-template>
          </div>
          <div class="mmc-advisor-values">{{modelData.sociallyResponsible}}</div>
        </div>
        <div class="block">
          <div class="mmc-advisor-label">Turnover:
            <span class="infoIcon"
              calltoaction [calltoactionTemplate]="turnoverTemplateRef"
            calltoactionPosition="bottom"></span>
            <ng-template #turnoverTemplateRef>
              This is the annual turnover for this model for the previous calendar year.
              Turnover is calculated by taking the total net buys and sells and dividing that
              by the portfolio (or representative account) value.
            </ng-template>
          </div>
          <div class="mmc-advisor-values" [innerHTML]="modelData.turnover"></div>
        </div>
        <div class="block">
          <div class="mmc-advisor-label">Allocation changes:
            <span class="infoIcon"
              calltoaction [calltoactionTemplate]="allocChanTemplateRef"
            calltoactionPosition="bottom"></span>
            <ng-template #allocChanTemplateRef>
              This indicates if allocations are adjusted quarterly, annually, monthly,
              continuously/as needed, or never.
            </ng-template>
          </div>
          <div class="mmc-advisor-values">{{modelData.allocation_changes}}</div>
        </div>
        <div class="block">
          <div class="mmc-advisor-label">Last allocation changes:
            <span class="infoIcon"
              calltoaction [calltoactionTemplate]="modifiedDtTemplateRef"
            calltoactionPosition="bottom"></span>
            <ng-template #modifiedDtTemplateRef>
              The day when the model allocations, or security targets, were most recently
              changed by the Model Manager.
            </ng-template>
          </div>
          <div class="mmc-advisor-values">{{modelData.modifiedDate}}</div>
        </div>
      </div>
    </div>
  }
</ng-template>
</mat-expansion-panel>
<mat-expansion-panel (closed)="localEditorService.updateExpansionState('MMCADVISORPERFORMANCE','closed')"
  (opened)="localEditorService.updateExpansionState('MMCADVISORPERFORMANCE','opened')"
  [expanded]="localEditorService.getDefaultExpansionState('MMCADVISORPERFORMANCE')"
  id="MMCADVISORPERFORMANCE">
  <mat-expansion-panel-header>
    <mat-panel-title>
      Performance
    </mat-panel-title>
  </mat-expansion-panel-header>
  <ng-template matExpansionPanelContent>
    @if (modelData) {
      <div>
        <div class="block">
          <div class="mmc-advisor-left left">
            <div class="mmc-advisor-label">Performance as-of date:
              <span class="infoIcon"
                calltoaction [calltoactionTemplate]="metricsTemplateRef"
              calltoactionPosition="bottom"></span>
              <ng-template #metricsTemplateRef>
                <div style='width:300px; margin:2px;'>
                  <div class="block">Net return calculations from the performance as-of-date
                    for the following:
                  </div>
                  <div class="block note"><em><strong>Please Note:</strong> net returns data cannot include any
                hypothetical or back-tested results.</em></div>
                <div class="block">
                  <div>1MO - Last month</div>
                  <div>T3 - Trailing 3 months</div>
                  <div>YTD - Year to date</div>
                  <div>1YR - Trailing 1 year</div>
                  <div>3YR - Trailing 3 years</div>
                  <div>5YR - Trailing 5 years</div>
                  <div>10YR - Trailing 10 years</div>
                </div>
                <div class="block">
                  <div>As-of Inception Date</div>
                  <div>As-of Inception Return %</div>
                </div>
                <div>Model Manager Performance Information:</div>
                <div>Performance information displayed on the Model Market Center (MMC) is not calculated, reviewed, or verified by either Schwab or the MMC. Advisors are solely responsible for verifying the accuracy of any investment performance information provided through the MMC. Schwab does not recommend the use of technical analysis as a sole means of investment research. MMC is not intended to be investment advice or a recommendation of any security. Investing in securities can be volatile and involves risk, including loss of principal. Consider your client’s individual circumstances.</div>
              </div>
            </ng-template>
          </div>
          <div class="mmc-advisor-values perf-metrics">{{modelData.performanceasof}}</div>
        </div>
        <div class="mmc-advisor-left left" style="margin-left: 40px;">
          <div class="mmc-advisor-label" style="width: auto; margin-right: 10px;">GIPS-compliant:
            <span class="infoIcon"
              calltoaction [calltoactionTemplate]="gipsTemplateRef"
            calltoactionPosition="bottom"></span>
            <ng-template #gipsTemplateRef>
              The Global Investment Performance Standards (GIPS) is a set of standardized,
              industry-wide ethical principles that guide investment firms on how to calculate
              and present their investment results using a live composite of accounts.
              Although a firm may be GIPS-compliant, this attribute lets you know if the
              performance numbers shown were collected in a GIPS-compliant. manner.
            </ng-template>
          </div>
          <div class="mmc-advisor-values perf-metrics">{{modelData.gips_compliant}}</div>
        </div>
        <br class="clear"/>
      </div>
      <div class="mmc-advisor-left block" style="display:flex;">
        <div class="mmc-advisor-label" style="width: auto; margin-right: 10px;">Performance
          metrics:
        </div>
        <div class="mmc-advisor-values perf-metrics" style="display:flex;">
          <div>
            1MO<br>{{modelData.me}}
          </div>
          <div>
            T3<br>{{modelData.t3}}
          </div>
          <div>
            YTD<br>{{modelData.ytd}}
          </div>
          <div>
            1YR<br>{{modelData.t12}}
          </div>
          <div>
            3YR<br>{{modelData.yr3}}
          </div>
          <div>
            5YR<br>{{modelData.yr5}}
          </div>
          <div>
            10YR<br>{{modelData.yr10}}
          </div>
        </div>
      </div>
    </div>
  }
  <div class="block">
    <div class="mmc-advisor-left left">
      <div class="mmc-advisor-label" style="width: auto; margin-right: 10px;">As-of inception date:</div>
      <div class="mmc-advisor-values perf-metrics">{{modelData.inceptionDate}}</div>
    </div>
    <div class="mmc-advisor-left left" style="margin-left: 40px;">
      <div class="mmc-advisor-label" style="width: auto; margin-right: 10px;">As-of inception return:</div>
      <div class="mmc-advisor-values perf-metrics">{{modelData.rorInception}}</div>
    </div>
    <br class="clear"/>
  </div>
  <div class="note" style="line-height: 16px;">
    Performance information displayed on the Model Market Center (MMC) is not calculated, reviewed, or verified by either Schwab or the MMC. Advisors are solely responsible for verifying the accuracy of any investment performance information provided through the MMC. Schwab does not recommend the use of technical analysis as a sole means of investment research. MMC is not intended to be investment advice or a recommendation of any security. Investing in securities can be volatile and involves risk, including loss of principal. Consider your client’s individual circumstances.
  </div>
</ng-template>
</mat-expansion-panel>
<mat-expansion-panel (closed)="localEditorService.updateExpansionState('MMCADVISORBACKCOST','closed')"
  (opened)="localEditorService.updateExpansionState('MMCADVISORBACKCOST','opened')"
  [expanded]="localEditorService.getDefaultExpansionState('MMCADVISORBACKCOST')"
  id="MMCADVISORBACKCOST">
  <mat-expansion-panel-header>
    <mat-panel-title>
      Background & Cost
    </mat-panel-title>
  </mat-expansion-panel-header>
  <ng-template matExpansionPanelContent>
    @if (modelData) {
      <div>
        <div class="mmc-advisor-left mmc-advisor-back-cost">
          <div class="block">
            <div class="mmc-advisor-label">Strategist Fee:
              <span class="infoIcon"
                calltoaction [calltoactionTemplate]="stratFeeTemplateRef"
              calltoactionPosition="bottom"></span>
              <ng-template #stratFeeTemplateRef>
                This number represents the cost – in basis points – assessed to the advisor for
                using this model/product. It is otherwise known as a strategist fee. This number
                does not include the underlying fund expenses that an investor will pay for
                purchasing securities included in the model's allocations.
              </ng-template>
            </div>
            <div class="mmc-advisor-values">{{ modelData.costBPs }}</div>
          </div>
          <div class="block">
            <div class="mmc-advisor-label">Weighted net expense ratio:
              <span class="infoIcon"
                calltoaction [calltoactionTemplate]="weightedNetTemplateRef"
              calltoactionPosition="bottom"></span>
              <ng-template #weightedNetTemplateRef>
                The weighted net expense ratio is the estimated cost investors are charged to be
                invested in the model. It is calculated by multiplying each security's net
                expense ratio by its respective target weighting and summing the result for all
                securities in the model.
              </ng-template>
            </div>
            <div class="mmc-advisor-values">{{ modelData.weightedNetExpenseRatio }}</div>
          </div>
          <div class="block">
            <div class="mmc-advisor-label">Suggested minimum:
              <span class="infoIcon"
                calltoaction [calltoactionTemplate]="suggestedMinTemplateRef"
              calltoactionPosition="bottom"></span>
              <ng-template #suggestedMinTemplateRef>
                Based on the model's strategy and allocations, the manager may suggest that this model only be used for clients' portfolios that are above this minimum amount. The iRebal system will not force you to adhere to this minimum.
              </ng-template>
            </div>
            <div class="mmc-advisor-values">{{ modelData.suggestedMinimum }}</div>
          </div>
          <div class="block">
            <div class="mmc-advisor-label">Estimated transaction fee:
              <span class="infoIcon"
                calltoaction [calltoactionTemplate]="estTranFeeTemplateRef"
              calltoactionPosition="bottom"></span>
              <ng-template #estTranFeeTemplateRef>
                This is the estimated transaction fee that would be incurred by an investor to implement the ETFs, exchange-listed stocks, and Mutual Funds in the model in an all-cash portfolio. This can also help you identify the models with underlying securities that have no commission fees. Note: Certain investor subaccounts, like employee retirement plans, Personal Choice Retirement Accounts (PCRAs) and Health Savings Accounts (HSAs), may be subject to holding availability and transaction fees. Advisors should confirm the fund availability before model implementation. Please contact iRebal Support at 866-640-2472 for more information.
              </ng-template>
            </div>
            <div class="mmc-advisor-values">{{ modelData.estimatedTransactionFee }}</div>
          </div>
          <div class="block">&nbsp;</div>
        </div>
        <div class="mmc-advisor-right">
          <div class="block">
            <div class="mmc-advisor-label">Firm founded:</div>
            <div class="mmc-advisor-values">{{modelData.firmFoundedDate}}</div>
          </div>
          <div class="block">
            <div class="mmc-advisor-label">Assets Under Management:</div>
            <div class="mmc-advisor-values">{{modelData.aum}}</div>
          </div>
          <div class="block">
            <div class="mmc-advisor-label">Website:</div>
            <div class="mmc-advisor-values">{{modelData.firmWebsite}}</div>
          </div>
          <div class="block">
            <div class="mmc-advisor-label">Contact:</div>
            <div class="mmc-advisor-values">{{modelData.firmPhone}}</div>
          </div>
          <div class="block">
            <div class="mmc-advisor-label">Email:</div>
            <div class="mmc-advisor-values">{{modelData.firmEmail}}</div>
          </div>
        </div>
      </div>
    }
  </ng-template>
</mat-expansion-panel>
</mat-accordion>
<div style="height: 10px; visibility:hidden"></div>
<div>
  <span class="AdvDis" ><a style="font-size: 13px;" (click)="showMMCFooterDialog()">Model Market Center Disclaimer</a> </span>
  @if (isShowDisclosureOnModelDetails) {
    <span> <a style="font-size: 13px;" (click)="checkForManagerDisclosure()">Model Manager and Advisor Disclosure</a></span>
  }
  <a class="edit-mmc-model-adv-link" style="padding-left:10px;"
  href="https://www.schwab.com/resource/Schwab-model-market-center" target="_blank" (click)="download_adv()">Disclosure Brochure</a><br>
</div>
</div>
<irb-common-dialog #dialog></irb-common-dialog>
</div>
}
